import { type ContextFn, format, type Locale, parse } from "date-fns";

/** Local-date → "YYYY-MM-DD" (no timezone shift). */
export function toIsoDate(d: Date): string {
	const y = d.getFullYear();
	const m = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${y}-${m}-${day}`;
}

/**
 * "HH:mm" slot start → a locale/time-format-aware label: 24-hour for
 * Indonesian, AM/PM otherwise. Mirrors the appointment date-time picker so the
 * kalender slot time blocks and the selected-visit summary read consistently.
 */
export function formatSlotTime(
	time: string,
	locale: Locale,
	tzDate?: ContextFn<Date>,
): string {
	const parsed = parse(time, "HH:mm", new Date(), { locale, in: tzDate });
	return format(parsed, locale.code === "id" ? "HH:mm" : "hh:mm a", {
		locale,
		in: tzDate,
	});
}

/** "YYYY-MM-DD" → a short localized date label, e.g. "11 Jul 2026". */
export function formatIsoDate(iso: string, locale: Locale): string {
	const parsed = parse(iso, "yyyy-MM-dd", new Date());
	return format(parsed, "d MMM yyyy", { locale });
}
